module.exports = __webpack_public_path__ + "static/AngelaHe3-16b2dc6642dbee647eea80213c3ab34e.png";